import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getSquads = (state: IStore) => state.squads.squads;

export const getSquadById = createSelector(
	getSquads,
	(squads) => (squadId: number) => squads.find((s) => s.id === squadId)
);
